import { nodeComponentRegistry } from '../../../r3f/NodeComponentRegistry';
import { CPUParticles2D } from './Component';
nodeComponentRegistry.register({
    typeName: 'CPUParticles2D',
    Component: CPUParticles2D,
    canvasItem: true,
});
//# sourceMappingURL=index.r3f.js.map